import _ from 'lodash'
import Cookies from 'js-cookie'
import config from '../config'

export const state = () => {
  // default values
  return {
    user: null
  }
}

const SET_USER = 'setUser'

export const mutations = {
  [SET_USER]: (state, user) => {
    state.user = user
  }
}

export const actions = {
  setUser: function({ commit }, user) {
    commit(SET_USER, user)
  },
  logout: function({ commit }) {
    commit(SET_USER, null)
    Cookies.remove('csrf-token')
  },
  changeLocale: function({ commit }, locale) {
    Cookies.set(config.COOKIE_NAME__LOCALE, locale, {
      expires: 7
    })

    window.location.reload(true)
  }
}

export const getters = {
  isAuthenticated: (state) => {
    // don't fully rely on this method to check authentication. this is semi trusted
    return typeof state.user !== 'undefined' && state.user !== null
  },

  getUsername: (state) => {
    if (state.user !== null) {
      return state.user.full_name
    }

    return ''
  },

  getAllowedSurveys: (state) => {
    if (state.user !== null) {
      return _.orderBy(
        state.user.allowed_surveys,
        ['year', 'id'],
        ['desc', 'asc']
      )
    }

    return []
  },

  isShowTutorial: (state) => () => {
    if (state.user !== null) {
      return state.user.is_show_tutorial
    }

    return true
  },

  getSurvey: (state) => (slug) => {
    const surveys = state.user !== null ? state.user.allowed_surveys : []
    return surveys.find((s) => s.country.slug === slug)
  },

  getLocale: () => {
    return Cookies.get(config.COOKIE_NAME__LOCALE)
  }
}
